module.exports = __webpack_public_path__ + "static/img/2.b9bdb26f.png";